import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const CheckOutModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    commuteSeq: 0,
    fkWorkerId: '',
    workerName: '',
    leaveReason: '',
    leaveCheckYn: 'N',
  });
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    setItem(props.props?.data.item);
  }, [props]);

  const setGetOff = () => {
    if (!isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to check?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const obj = {
              state: 'E'
            };

            Server.sendPut('workforce/commute/manager-check', { ...item, ...obj }, setGetOffCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const setGetOffCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  return (
    <>
      <CloseBtn onClick={closeModal} />
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>The reason for leaving early</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <FormInWrap>
                <label>Date</label>
                <FormInput
                    type='text'
                    id='workDate'
                    name='workDate'
                    readOnly={true}
                    value={item?.workDate || ''}
                />
              </FormInWrap>
              <FormInWrap>
                <label>Name</label>
                <FormInput
                    type='text'
                    id='workerName'
                    name='workerName'
                    readOnly={true}
                    value={item?.workerName || ''}
                />
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormTextWrap>
                <label>Reason</label>
                <textarea
                    id='leaveReason'
                    name='leaveReason'
                    readOnly={true}
                    value={item?.leaveReason || ''}
                />
              </FormTextWrap>
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              {item?.leaveCheckYn === 'N' && <Btn $Color onClick={setGetOff}>Check</Btn>}
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 15px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(85% - 7px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 50%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
    }
  }
`;

const FormTextWrap = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 150px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: calc(15% - 3px);

    & span {
      font-size: 11px;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default CheckOutModal;